export default {
  DOMAIN:
    process.env.REACT_APP_API_URL_ADMIN || "http://52.143.165.77:3001/admin/", // production
  // DOMAIN: "http://localhost:3001/admin/", // Local
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/x-www-form-urlencoded",
    apikey: "$2b$10$pY7lON5vJj3fX5iT24Pymeqf6QuF5bIEMI4dAjzL/mjFUKBbFLIP6",
    domain: "https://front.dev.web2printsolution.com",
  },
  URL_BASE_IMAGE:
    process.env.REACT_APP_URL_BASE_IMAGE || "https://content.click2printsolutions.com",
};
